const DEFAULT_ORIGIN = 'https://apexdefie.com';

function getOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    const { hostname, protocol } = window.location;
    // Локальная разработка (localhost ИЛИ доступ по локальной сети с телефона):
    // фронт на :3000, бэкенд на :8000 на том же хосте.
    const isDevHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(hostname);
    if (isDevHost) {
      return `${protocol}//${hostname}:8000`;
    }
    return window.location.origin;
  }
  return DEFAULT_ORIGIN;
}

function toWsOrigin(origin) {
  return origin.replace(/^http/, 'ws');
}

export const BACKEND_BASE = getOrigin();
export const URL_API = `${BACKEND_BASE}/api`;
export const WS_BASE = toWsOrigin(BACKEND_BASE);
export const WS_RATE_URL = `${WS_BASE}/ws/rate`;
export const WS_BAL_URL = `${WS_BASE}/ws/balance`;
